import { httpClient } from '../../../lib/utils';
import { envValue } from '../../../config/envUtils';

const SPLUNK_URL = envValue('SPLUNK_URL');

export function postRequestToSplunk(callType, url, timestamp) {
    if (url !== `${SPLUNK_URL}/v1/app/log/collector/event`) {
        httpClient.post(
            `${SPLUNK_URL}/v1/app/log/collector/event`,
            {
                ChannelId: 'NGBE',
                EventData: {
                    time: timestamp,
                    source: 'BEDesigner UI',
                    event: {
                        ServiceURL: url,
                        Method: callType,
                        time: timestamp
                    }
                }
            }
        );
    }
}

export function postResponseToSplunkSuccess(callType, url, timestamp, statusCode) {
    const SPLUNK_URL = envValue('SPLUNK_URL');
    if (url !== `${SPLUNK_URL}/v1/app/log/collector/event`) {
        httpClient.post(
            `${SPLUNK_URL}/v1/app/log/collector/event`,
            {
                ChannelId: 'NGBE',
                EventData: {
                    ResponseTime: timestamp,
                    source: 'BEDesigner UI',
                    event: {
                        ServiceURL: url,
                        Method: callType,
                        StatusCode: statusCode,
                        ResponseTime: timestamp
                    }
                }
            }
        );
    }
}

export function postResponseToSplunkFailed(callType, url, timestamp, errorMessage) {
    const SPLUNK_URL = envValue('SPLUNK_URL');
    if (url !== `${SPLUNK_URL}/v1/app/log/collector/event`) {
        httpClient.post(
            `${SPLUNK_URL}/v1/app/log/collector/event`,
            {
                ChannelId: 'NGBE',
                EventData: {
                    ResponseTime: timestamp,
                    source: 'BEDesigner UI',
                    event: {
                        ServiceURL: url,
                        Method: callType,
                        Error: errorMessage,
                        ResponseTime: timestamp
                    }
                }
            }
        );
    }
}



// WEBPACK FOOTER //
// ./src/services/logging/splunklogging.js